module.exports = __webpack_public_path__ + "front/img/b19.d8058afa.jpg";